import React, { useState } from 'react'

import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'

import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined'

import { useRecordLock } from '../../contexts/RecordLockContext'

const DeleteConfirmation = ({
  openBtn,
  type,
  id,
  deleteToolTip,
  handleDeleteFn,
}) => {
  const { recordLock } = useRecordLock()
  const [open, setOpen] = useState(false)
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const handleDelete = () => {
    handleDeleteFn()
    handleClose()
  }
  return (
    <>
      {openBtn === 'actionBar' && (
        <Tooltip title={deleteToolTip || `Delete Record`} arrow>
          <Button
            variant='outlined'
            sx={{ py: 1, m: 1 }}
            color='error'
            onClick={handleOpen}
          >
            <RemoveCircleOutlineIcon />
          </Button>
        </Tooltip>
      )}
      {openBtn === 'smIcon' && (
        <Tooltip title={deleteToolTip || `Delete Record`} arrow>
          <IconButton
            variant='outlined'
            onClick={handleOpen}
            color='error'
            sx={{ height: 25, width: 25 }}
            disabled={!recordLock}
          >
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} sx={{ m: 1, textAlign: 'center' }}>
              <Typography variant='h5'>Delete {type}</Typography>
              <Typography>{id}</Typography>
            </Grid>
            <Grid item>
              <Typography>
                Are you sure you want to delete {type} {id}?
              </Typography>
              <Typography>Note: This can not be undone.</Typography>
            </Grid>
            <Grid item xs={12} sx={{ m: 1, textAlign: 'center' }}>
              <Button
                variant='outlined'
                sx={{ py: 1, m: 1 }}
                color='error'
                onClick={handleDelete}
              >
                <RemoveCircleOutlineIcon />
              </Button>
              <Button
                variant='outlined'
                sx={{ py: 1, m: 1 }}
                color='dark'
                onClick={handleClose}
              >
                <ReplayOutlinedIcon />
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DeleteConfirmation
